import View from '@shared/components/layout-default/layout-default-router-view';

export const stats = {
  path: 'stats',
  component: View,
  children: [
    {
      path: '',
      name: 'pbx.stats.index',
      redirect: {
        name: 'pbx.stats.type',
        params: {
          type: 'detailed'
        }
      }
    },
    {
      path: ':type(general|detailed)',
      name: 'pbx.stats.type',
      component: () =>
        import(
          /* webpackChunkName: 'pbx' */
          '@pbx/pages/stats'
        ),
      meta: {
        title: {
          code: 'shared.breadcrumb.stats.title'
        }
      }
    }
  ]
};
